import { getFromDonationApi } from 'actions';
import config from '../../config';

export default resourcePath =>
  getFromDonationApi(`${config.donationService.baseUrl}${resourcePath}`);
